import { useTelemetry } from '@amzn/xb-hooks';
import { TELEMETRY_EVENT_TYPES } from './TelemetryEvents';

/**
 * Hook for tracking user events via Adobe Analytics telemetry.
 * Wraps xb-hooks useTelemetry.
 *
 * Note: requires ExperienceBridgeProvider to be in the component tree.
 */
export const useTrackUserEvent = () => {
    const { trackEvent } = useTelemetry();

    return (type: TELEMETRY_EVENT_TYPES, name: string, additionalData?: Record<string, unknown>) => {
        trackEvent(type, name, additionalData ? { data: additionalData } : undefined);
    };
};
